import { render } from "./ProfileAbout.vue?vue&type=template&id=b3e4c924&scoped=true"
import script from "./ProfileAbout.vue?vue&type=script&lang=js"
export * from "./ProfileAbout.vue?vue&type=script&lang=js"

import "./ProfileAbout.vue?vue&type=style&index=0&id=b3e4c924&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b3e4c924"

export default script